import creativeWordmark from "@/assets/404-creative-wordmark.png";
import { client } from "@/config/client";
import { useT } from "@/shared/i18n/useT";
import { EstateLockup } from "@/shared/ui/brand/EstateLockup";
import { Dialog } from "@/shared/ui/Dialog";

export function AboutDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const t = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={t("shell.about")}>
      <div className="art-grain relative isolate overflow-hidden rounded-xl bg-art px-6 py-7">
        <div aria-hidden="true" className="art-grid absolute inset-0 -z-10" />
        <EstateLockup tone="dark" />
        <p className="mt-4 max-w-sm text-[14.5px] leading-relaxed text-art-ink-muted">
          {t("about.body", { company: client.companyName })}
        </p>
        <div className="mt-6 flex items-center gap-3">
          <img src={creativeWordmark} alt="404 Creative" className="h-7 w-auto" />
          <span className="text-[12.5px] text-art-ink-muted">{t("auth.art.crafted")}</span>
        </div>
      </div>
      <p className="mt-4 text-[13px] text-ink-subtle">
        {t("about.version", { version: __APP_VERSION__ })}
      </p>
    </Dialog>
  );
}
